export function resolveStatusClass(statusKey) {
  if (typeof(statusKey) !== 'string') {
    return ''
  }
  if (['active', 'in stock', 'in p.o.', 'completed', 'accepted', 'received', 'delivered', 'committed', 'in_stock', 'paid'].indexOf(statusKey) !== -1) {
    return 'status-completed'
  }
  if (['allocated', 'sent', 'ready_to_send', 'send_to_supplier', 'ongoing'].indexOf(statusKey) !== -1) {
    return 'status-allocated'
  }
  if (['inactive', 'draft'].indexOf(statusKey) !== -1) {
    return 'status-request'
  }
  if (['in_stock'].indexOf(statusKey) !== -1) {
    return 'status-in_stock'
  }
  if (['cancelled', 'declined', 'deleted', 'rejected', 'returned', 'on_hold'].indexOf(statusKey) !== -1) {
    return 'status-cancelled'
  }
  if (['inactive', 'pending', 'collections', 'credit hold', 'overdue', 'expired', 'reverted', 'in_transit', 'credit_hold', 'no_longer_available', 'resend'].indexOf(statusKey) !== -1) {
    return 'status-inprogress'
  }
  return ''
}
